const { logError } = require('./logger')
    
const STATES = {
  IDLE: 0,
  RUNNING: 1,
  PAUSED: 2,
  RESUMED: 3,
  DONE: 4
}

const IntervalTimer = function(callback, interval) {
  try {
    let lastResumeTime = new Date().getTime()
    let remaining = interval
    let timerId = null
    let state = STATES.RUNNING

    this.pause = function () {
      if (state === STATES.RUNNING || state === STATES.RESUMED) {
        remaining += lastResumeTime - new Date().getTime()
        clearTimeout(timerId)
        state = STATES.PAUSED
      }
    }

    this.resume = function () {
      if (state === STATES.PAUSED) {
        state = STATES.RESUMED
        clearTimeout(timerId)
        timerId = setTimeout(this.timeoutCallback, remaining)
        lastResumeTime = new Date().getTime()
      }
    }

    this.timeoutCallback = () => {
      try {
        if (state === STATES.RUNNING || state === STATES.RESUMED) {
          lastResumeTime = new Date().getTime()
          remaining = interval
          clearTimeout(timerId)

          if (callback) {
            callback()
            timerId = setTimeout(this.timeoutCallback, interval)
            state = STATES.RUNNING
          }
        }
      } catch (err) {
        logError(err, {
          module: 'IntervalTimer',
          func: 'timeoutCallback',
          callback,
          interval
        })
      }       
    }

    if (timerId) {
      clearTimeout(timerId)
    }
    timerId = setTimeout(this.timeoutCallback, interval)

    this.dispose = () => {
      clearTimeout(timerId)
      state = STATES.DONE
      callback = null
    }
  } catch (err) {
    logError(err, {
      module: 'IntervalTimer',
      func: 'constructor',
      callback,
      interval
    })
  }
}
module.exports = IntervalTimer
